import { MenuItem, Select } from '@vapor/material'
import { FormItem } from 'hic-components'
import { useTranslation } from 'react-i18next'
import { useTenant } from 'src/app/hooks/context/context.hook'
import { useGetSortedVats } from 'src/app/hooks/use-get-sorted-vats/use-get-sorted-vats'

type VatSelectProps = {
  value: string
  onChange: (value: string) => void
  errorMessage?: string
  disabled?: boolean
  size?: 'small' | 'medium'
  label?: string
}

export default function VatsSelect(props: VatSelectProps) {
  const { onChange, value, disabled, errorMessage, size = 'small', label } = props
  const { t } = useTranslation()
  const { id: tenantId } = useTenant()
  const { vats, loading } = useGetSortedVats(tenantId)

  return (
    <FormItem //
      fieldLabel={label ?? t('pms.common.customer.vat')}
      errorMessage={errorMessage}
      fullWidth
    >
      <Select
        disabled={disabled || loading}
        value={value}
        onChange={(event) => {
          onChange(event.target.value as string)
        }}
        size={size}
      >
        <MenuItem value={''}></MenuItem>
        {vats.map((vat) => (
          <MenuItem key={vat.id} value={vat.id}>
            {`${(vat.value * 100).toFixed(0)}% (${vat.description})`}
          </MenuItem>
        ))}
      </Select>
    </FormItem>
  )
}
